@if (isActive()) {
    <div class="py-32 lg:py-40">
        <h1 class="leading-29 mb-12 text-24 lg:text-34 lg:leading-41">So einfach geht es zu Ihrem Wunschauto</h1>

        <ui-m040-c140-tabs
            [options]="[
                {
                    value: 'probefahrt',
                    label: 'Probefahrt',
                    content: testdrive,
                    visible: true,
                },
                {
                    value: 'allg-anfrage',
                    label: 'Allgemeine Anfrage',
                    content: generalrequest,
                    visible: true,
                },
                {
                    value: 'reservierung',
                    label: 'Reservieren',
                    content: reservation,
                    visible: true,
                },
            ]"
            [control]="form.controls.tab"
            small
        />
    </div>

    <ng-template #testdrive>
        <lib-distribution-testdrive-step [form]="form" [vehicle]="vehicle()" (submitClicked)="next()" />
    </ng-template>

    <ng-template #generalrequest>
        <lib-distribution-generalrequest-step [form]="form" [vehicle]="vehicle()" (submitClicked)="next()" />
    </ng-template>

    <ng-template #reservation>
        <lib-distribution-reservation-step [form]="form" [vehicle]="vehicle()" (submitClicked)="next()" />
    </ng-template>
}
